import styled from 'styled-components';

export const HeaderSidebarWrapper = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100vh;
  z-index: 999;
  display: ${(props) => (props.showSidebar ? 'unset' : 'none')};
  /* visibility: ${(props) => (props.showSidebar ? 'visible' : 'hidden')}; */
  background-color: rgba(0, 0, 0, 0.95);
  #sidebar-container {
    width: 100%;
    margin-left: auto;
    height: 100vh;
    max-width: 400px;
    overflow-y: auto;
    background-color: white;
  }
  #sidebar-top {
    background-color: var(--color-brick);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2.2rem;
    #sidebar-logo-container {
      #sidebar-logo {
        width: auto;
        height: 35px;
        flex-grow: 1;
      }
    }
    #sidebar-close {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      width: 40px;
      height: 40px;
      flex-grow: 1;
      .header-item-with-icon {
        font-size: 2rem;
        cursor: pointer;
        color: white;
        font-weight: 800;
        text-decoration: none;
        margin-right: 0.5rem;
      }
    }
  }
  #sidebar-middle {
    #sidebar-tabs-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .tab {
      }
    }
  }
  @media (max-width: 991px) {
    margin: 0px;
  }
`;
